export default {
    methods : {
        //mixin pour créer différents array d'etapes s'ils se chevauchent
        getItemsOrdered: function(steps){
            let globalArray = [];
            steps.forEach(step => {
                let stepStart = new Date(step.start).getTime();
                let stepEnd;
                if(step.period){
                    stepEnd = new Date(step.end).getTime();
                }
                let pushed = false;
                for (let index = 0; index < globalArray.length; index++) {
                    const element = globalArray[index];
                    let push = true;
                    element.forEach(orderedStep => {
                        let orderedStepStart = new Date(orderedStep.start).getTime();
                        let orderedStepEnd;
                        if(orderedStep.period){
                            orderedStepEnd = new Date(orderedStep.end).getTime();
                            if((stepStart >= orderedStepStart && stepStart <= orderedStepEnd) || (step.period && stepEnd >= orderedStepStart && stepEnd <= orderedStepEnd)){
                                push = false
                            }
                        } else {
                            if(stepStart == orderedStepStart || (step.period && stepEnd == orderedStepStart)){
                                push = false
                            }
                        }
                    });
                    if (push){
                        element.push(step)
                        pushed = true;
                        break;
                    }
                }
                if(!pushed){
                    globalArray.push([step])
                }                
            });
            return globalArray.sort((a, b)=> {
                return b.length - a.length
            })
        }
    }
}